import { Input } from "@/components/ui/input";
import { ChangeEvent } from "react";

interface SearchInputProps {
	value: string;
	onChange: (value: string) => void;
	placeholder?: string;
	className?: string;
	autoFocus?: boolean;
	loading?: boolean;
}

const SearchInput: React.FC<SearchInputProps> = ({
	value,
	onChange,
	placeholder = "Search...",
	className = "w-50",
	autoFocus = false,
	loading = false,
}) => {
	const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
		if (!loading) {
			onChange(e.target.value);
		}
	};
	const laodingClass = loading ? "cursor-not-allowed opacity-50 " : "";
	return (
		<Input
			value={value}
			onChange={handleChange}
			placeholder={placeholder}
			className={laodingClass + className}
			autoFocus={autoFocus}
		/>
	);
};

export { SearchInput };
